import {Map as OlMap, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import {View as ReactView} from "react-native";
import {useContext, useEffect, useState} from "react";
import {transform} from "ol/proj";
import {Coordinate} from "ol/coordinate";
import PropTypes from "prop-types";
import FontAwesome from "../../themes/baran/components/FontAwesome";
import {Colors} from "../../themes/baran/colors";
import AppConfigContext from "../../contexts/AppConfigContext";
import {randomStr} from "../../helpers";

export type LatLong = { lat: number, long: number };

function Map(props: any) {
    const color = Colors.instance(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);

    const [domId, setDomId] = useState<string>(`ol-map-${randomStr(6)}`);
    const [map, setMap] = useState<OlMap | null>(null);
    const [defaultLocationHasSet, setDefaultLocationHasSet] = useState<boolean>(false);

    const tileLayer = new TileLayer({
        source: new OSM()
    });

    useEffect(() => {

        let defLoc;
        if (props.defaultLocation != undefined)
            defLoc = props.defaultLocation;
        else defLoc = {lat: 35.83, long: 50.97}

        setMap(new OlMap({
            target: domId,
            layers: [tileLayer],
            controls: [],
            view: new View({
                center: toWebCoords(defLoc),
                zoom: 12
            })
        }));
    }, []);

    useEffect(() => {
        if (map != null && !defaultLocationHasSet) {
            map?.getView().setCenter(toWebCoords(props.defaultLocation));
            map?.getView().setZoom(18);
        }
        setDefaultLocationHasSet(true);
    }, [props.defaultLocation]);

    useEffect(() => {
        if (map != null) {
            map.on("moveend", (event) => {
                if (props.onLocationSelect != undefined)
                    props.onLocationSelect(toLatLong(map.getView().getCenter() as Coordinate));
            });
        }
    }, [map]);

    return <ReactView style={{
        width: props.width,
        height: props.height,
        minHeight: 150,
        flexDirection: "column",
        justifyContent: "center",
        overflow: "hidden",
        alignItems: "center",
        borderRadius: props.borderRadius ?? 8,
        backgroundColor: color.get("lowConBackground") as string
    }}>
        <ReactView style={{width: "100%", height: "100%"}}>
            <div id={domId} style={{height: "100%", width: "100%"}}></div>
            {/*todo: fix the marker in center*/}
        </ReactView>
        {props.function == "overview" ? <StaticMarker size={26}/> : <Marker mapHeight={props.height} size={32}/>}
    </ReactView>
}

function toLatLong(coords: Coordinate): LatLong {
    const latlong = transform(coords, 'EPSG:3857', 'EPSG:4326');
    return {lat: latlong[1], long: latlong[0]};
}

function toWebCoords(latLong: LatLong): Coordinate {
    return transform([latLong.long, latLong.lat], 'EPSG:4326', 'EPSG:3857');
}

function Marker({mapHeight, size}: { mapHeight: number, size: 32 }) {
    const color = Colors.instance(useContext(AppConfigContext).theme, useContext(AppConfigContext).color).get("primaryColor");
    return <FontAwesome style={{
        position: "absolute",
        transform: [{translateY: -((mapHeight / 2) + size)}],
        alignSelf: "center",
        textShadowColor: '#0005',
        textShadowOffset: {width: -2, height: -2},
        textShadowRadius: 2
    }} icon={""} size={size} color={color as string}/>
}

function StaticMarker({size}: { size: number }) {
    const color = Colors.instance(useContext(AppConfigContext).theme, useContext(AppConfigContext).color).get("primaryColor");
    return <ReactView
        style={{width: "100%", height: "100%", justifyContent: "center", alignItems: "center", position: "absolute"}}>
        <FontAwesome style={{
            transform: [{translateY: -(size / 2)}],
            alignSelf: "center",
            textShadowColor: '#0005',
            textShadowOffset: {width: -2, height: -2},
            textShadowRadius: 2
        }} icon={""} size={size} color={color as string}/>
    </ReactView>
}

Map.propTypes = {
    function: PropTypes.oneOf(["areaSelect", "locationSelect", "overview"]),
    onAreaSelect: PropTypes.func,
    onLocationSelect: PropTypes.func,
    defaultSelection: PropTypes.shape({
        range: PropTypes.number.isRequired,
        latlong: PropTypes.shape({
            lat: PropTypes.number.isRequired,
            long: PropTypes.number.isRequired
        }).isRequired
    }),
    defaultLocation: PropTypes.shape({
        lat: PropTypes.number.isRequired,
        long: PropTypes.number.isRequired
    }),
    width: PropTypes.any,
    height: PropTypes.any,
    borderRadius: PropTypes.number,
    role: PropTypes.any
}

export default Map;